import React, {ChangeEvent, useEffect, useRef, useState} from 'react'
import {useHistory, useLocation} from 'react-router';
import {
    FormControlLabel,
    Checkbox,
    FormControl,
    MenuItem,
} from "@mui/material";
import {
    Page,
    Container, ChangeRoleBlock, ContinueButton, InputPhoneBlock, NameBlock
} from "./SignUp1_DO.styles";
import * as ls from "local-storage";
import MaterialInput from "../../../components/Inputs/MaterialInput";
import HeaderStatusBar from "../../../components/HeaderStatusBar";
import {isNumber} from "lodash";
import MaskedInput from "react-input-mask";
import Api from "../../../api";
import {BodyContainer, BodyCountrySelect, HeaderCountrySelect, CountrySelectBlock} from "../SignUp1_Talent/SignUp1_Talent.styles";
import {Container as HeaderContainer, StarsContainer} from "components/SignUpHeader/SignUpHeader.styles";
import FixedLoader from "../../../components/FixedLoader/FixedLoader";
import useActionApi from "../../../hooks/useActionApi";
import { MARKETING_SOURCES } from "../../../utils/constants";
// @ts-ignore
const TempStars: any = window.TempStars;

interface ErrorProps {
    practiceName: string,
    ownersName: string,
    phone: string,
    address: string,
    country: string,
    document: string,
    marketingSource: string,
    otherSource: string,
}

interface AutocompleteProps {
    buildingNumber?: string
    state: string,
    city?: string,
    postalCode?: string,
    address?: string,
    valueEqual?: boolean
}

export interface completeRegistrationDoProps {
    practiceName: string,
    ownersName: string,
    phone: number,
    country: 0 | 1,
    autocomplete: AutocompleteProps,
    photoUrl?: string,
    marketingSource: string,
}

const filterPhoneNumberToFormat = (phoneNumber: string | undefined): number => {
    const arr = phoneNumber?.match(/\d+/g)
    return Number(arr?.slice(1).join(''))
}

interface SignUp1HeaderProps {
    title?: string,
    description?: string,
    error?: string
}

const SignUp1Header = ({title, description, error}: SignUp1HeaderProps) => {
    return <HeaderContainer>
        <div>
            <div className="screenDescription">
                {description}
            </div>
            <div className="screenTitle">
                {title}
            </div>
            {error && <div className="screenError">
                {error}
            </div>}
        </div>
        <div><StarsContainer/></div>
    </HeaderContainer>
}

export default function SignUp1_DO() {
    const history = useHistory();
    const { state } = useLocation<completeRegistrationDoProps>();
    const userAccount: {
        email: string;
        dentistId?: number,
        hygienistId?: number,
        dentist?: any,
        hygienist?: any
        id: number
    } = ls.get('userAccount') || {}

    const [country, setCountry] = useState<0 | 1>(isNumber(state?.country) ? state.country : 1); // 0 - CA
    const [screenError, setScreenError] = useState(false);
    const [autocompletedAddress, setAutocompletedAddress] = useState<AutocompleteProps | undefined>();
    const [errorMessage, setErrorMessage] = useState<ErrorProps | undefined>();
    const htmlElRef = useRef<HTMLInputElement>(null)
    const [loading, setLoading] = useState<boolean>(false);
    const [marketingSource, setMarketingSource] = useState<string>('');
    const [otherSource, setOtherSource] = useState<string>('');
    const analyticsTracked = useRef(false);

    const [changeRoleLoading, , changeRole] = useActionApi({
        apiMethod: Api.changeRole,
        onSuccess: () => history.push({pathname: 'SignUp1_Talent'}),
    });

    useEffect(() => {        
        TempStars.Autocomplete.init({country},({state, city, postalCode, address, buildingNumber, valueEqual}: AutocompleteProps) => {            
            if (!address && !buildingNumber && !city) {
                setAutocompletedAddress(undefined);
            } else if (valueEqual) {
                setAutocompletedAddress({state, city, postalCode, address, buildingNumber, valueEqual});
            }
        });
        
        return () => {
            TempStars.Autocomplete.removeListener();
        };
    }, [country])

    useEffect(() => {
        if (!analyticsTracked.current) {
            TempStars.Analytics.track('view_office_createAccount', {
                country: country === 0 ? 'CA' : 'US'
            });
            analyticsTracked.current = true;
        }
    }, [country]);

    useEffect(() => {
        if (!analyticsTracked.current) {
            TempStars.Analytics.track('view_office_createAccount', {
                country: country === 0 ? 'CA' : 'US'
            });
            analyticsTracked.current = true;
        }
    }, [country]);

    const changeCountry = (event: ChangeEvent<HTMLInputElement>) => {
        event.preventDefault()
        if (event.target.name === 'us') {
            setCountry(1)
        } else {
            setCountry(0)
        }
    }

    const onSubmit = async (event: any) => {
        event.preventDefault()
        setLoading(true);

        const {practiceName, ownersName, phone, address, ca, us} = event.target

        let errors = {}

        if (!practiceName.value.length) {
            errors = {...errors, practiceName: 'Please enter Practice Name'};
        }
        if (!ownersName.value.length) {
            errors = {...errors, ownersName: "Please enter Owner's Full Name"};
        }
        if (!phone.value.length || phone.value.length < 16) {
            errors = {...errors, phone: 'Please enter Mobile'};
        }
        
        if (!address.value.length && !autocompletedAddress) {
            errors = {...errors, address: 'Please enter your address'};
        } 
        else if (address.value.length && !autocompletedAddress) {
            errors = {...errors, address: 'Please select your address from the list'};
        }
        else if (autocompletedAddress && !autocompletedAddress.buildingNumber?.length) {
            errors = {...errors, address: 'Add your building #, street'};
        }
        
        if (country !== 0 && country !== 1) {
            errors = {...errors, country: 'Please choose your country'};
        }
        if (!marketingSource) {
            errors = {...errors, marketingSource: 'Please select how you heard about us'};
        }
        if (marketingSource.length > 150) {
            errors = {...errors, marketingSource: 'Response too long. Maximum 150 characters.'};
        }

        const phoneNumber = filterPhoneNumberToFormat(phone.value);

        if (phoneNumber.toString().length < 10) {
            errors = {...errors, phone: 'Phone number is too short.'};
        }

        if(Object.values(errors).find((err: any) => !!err.length)) {
            setErrorMessage(errors as ErrorProps);
            setLoading(false);
            return setScreenError(true);
        } else {
            setErrorMessage(undefined);
            setScreenError(false);
        }

        TempStars.Analytics.track( 'sign-up - complete dental office form');
        setLoading(false);
        
        if (!autocompletedAddress && address.value.length) {
            const defaultAddress = {
                state: country === 0 ? 'ON' : 'FL', // Default province/state based on country
                city: '',
                postalCode: '',
                address: address.value,
                buildingNumber: '1',
                valueEqual: true
            };
            
            const props = {
                practiceName: practiceName.value,
                ownersName: ownersName.value,
                phone: phoneNumber,
                country: country,
                autocomplete: defaultAddress,
                photoUrl: undefined,
                marketingSource: otherSource ? otherSource : marketingSource
            }
            
            return history.push({
                pathname: 'SignUp2_DO'
            }, props);
        }
        
        let props = {
            practiceName: practiceName.value,
            ownersName: ownersName.value,
            phone: phoneNumber,
            country: country,
            autocomplete: autocompletedAddress,
            photoUrl: undefined,
            marketingSource: otherSource ? otherSource : marketingSource
        }

        return history.push({
            pathname: 'SignUp2_DO'
        }, props)
    };

    const changeRoleToTalent = async () => {
        TempStars.Analytics.track('Select-Route', {
            route_selected: 'UserToTalent'
        });
        await changeRole(null);
    }

    return (
        <Page>
            <Container>
                <HeaderStatusBar buttonClassName={'logout-link'} buttonText={'Sign Out'} withArrow />

                <BodyContainer>
                    <SignUp1Header
                        title="Let's get to know your office..."
                        description="Dental Office Registration"
                        error={screenError ? 'Please fix the errors below' : undefined}
                    />

                    <form id="signup-form" className="content-block contentBlock" onSubmit={onSubmit}>
                        <NameBlock className="list-block inset">
                            <MaterialInput
                                inputRef={htmlElRef}
                                label="Practice Name"
                                type={"text"}
                                id={'practiceName'}
                                name={"practiceName"}
                                defaultValue={state?.practiceName || ''}
                                error={!!errorMessage?.practiceName}
                                helperText={!!errorMessage?.practiceName && errorMessage.practiceName}
                            />
                            <MaterialInput
                                label="Business Owner's Full Name"
                                id={'ownersName'}
                                name={"ownersName"}
                                type={"text"}
                                defaultValue={state?.ownersName || ''}
                                error={!!errorMessage?.ownersName}
                                helperText={!!errorMessage?.ownersName && errorMessage.ownersName}
                            />
                        </NameBlock>

                        <CountrySelectBlock className="list-block inset">
                            <HeaderCountrySelect>Where are you based?</HeaderCountrySelect>
                            <BodyCountrySelect>
                                <FormControlLabel
                                    className={'no-fastclick'}
                                    control={<Checkbox
                                        icon={<img id="officeCheckmark" className="hidden-icon" alt=""
                                                   src={"img/dotCheck_inactive.svg"}/>}
                                        checkedIcon={<img id="officeCheckmark" className="hidden-icon" alt=""
                                                          src={"img/dotCheck_active.svg"}/>}
                                        name="ca"
                                        checked={country === 0}
                                        onChange={changeCountry}
                                    />}
                                    label="Canada"
                                />
                                <FormControlLabel
                                    className={'no-fastclick'}
                                    control={<Checkbox
                                        icon={<img id="officeCheckmark" className="hidden-icon" alt=""
                                                   src={"img/dotCheck_inactive.svg"}/>}
                                        checkedIcon={<img id="officeCheckmark" className="hidden-icon" alt=""
                                                          src={"img/dotCheck_active.svg"}/>}
                                        name="us"
                                        checked={country === 1}
                                        onChange={changeCountry}
                                    />}
                                    label="USA"
                                />
                            </BodyCountrySelect>
                            <div className={'inputTextField'}>
                                <div id="agreed-error-msg" className={'errorMsg'}>
                                    {errorMessage?.country}
                                </div>
                            </div>
                        </CountrySelectBlock>

                        <div className="list-block inset inputBox">
                            <MaterialInput
                                className={'no-fastclick'}
                                label="Start typing your address ..."
                                id={'autocomplete'}
                                name={"address"}
                                type={"text"}
                                error={!!errorMessage?.address}
                                helperText={!!errorMessage?.address && errorMessage.address}
                            />
                        </div>

                        <InputPhoneBlock className="list-block inset">
                            {/* @ts-ignore */}
                            <MaskedInput
                                mask="+1(999) 999-9999"
                                defaultValue={state?.phone}
                            >
                                {/* @ts-ignore */}
                                {(inputProps: any) => (
                                    <MaterialInput
                                        {...inputProps}
                                        label="Office Phone Number"
                                        id={'phone'}
                                        name={"phone"}
                                        type={'text'}
                                        error={!!errorMessage?.phone}
                                        helperText={!!errorMessage?.phone && errorMessage.phone}
                                    />
                                )}
                            </MaskedInput>
                        </InputPhoneBlock>

                        <div className="list-block inset">
                            <FormControl fullWidth>
                                <MaterialInput
                                    select
                                    className={'no-fastclick'}
                                    label="How did you hear about us?"
                                    value={marketingSource}
                                    onChange={(e) => {
                                        setMarketingSource(e.target.value);
                                    }}
                                    error={!!errorMessage?.marketingSource}
                                    helperText={errorMessage?.marketingSource}
                                    name="marketingSource"
                                    id="marketing-source"
                                >
                                    {MARKETING_SOURCES.map((source) => (
                                        <MenuItem key={source.value} value={source.value}>
                                            {source.label}
                                        </MenuItem>
                                    ))}
                                </MaterialInput>
                            </FormControl>
                        </div>

                        {marketingSource === 'other' && (
                            <div className="list-block inset">
                                <MaterialInput
                                    label="Please specify"
                                    value={otherSource}
                                    onChange={(e) => setOtherSource(e.target.value)}
                                    error={!!errorMessage?.otherSource}
                                    helperText={errorMessage?.otherSource}
                                    name="otherSource"
                                />
                            </div>
                        )}

                        <ContinueButton
                            disabled={loading}
                            variant="contained"
                            color="primary"
                            size="large"
                            id="signup-button"
                            type={'submit'}
                        >
                            Continue
                        </ContinueButton>
                        <ChangeRoleBlock>Not a Dental Office? <a onClick={changeRoleToTalent}>Find temping and job opportunities for dental professionals here</a></ChangeRoleBlock>
                    </form>
                </BodyContainer>
                <div className="footer">
                </div>
            </Container>
            <FixedLoader loading={changeRoleLoading || loading}/>
        </Page>
    )
}
